import * as React from 'react';
import { RatingItem } from '../../components/RatingItem';
import { useToggleState } from '@cian/react-utils';

import { findMedal, generateDataForLinks } from './helpers';
import { useDeviceType } from '@cian/ui-kit';
import { RatingItemMobile } from '../../components/RatingItemMobile';

import defaultLogo from './assets/defaultLogo.svg';
import { useApplicationContext } from '../../../common/utils/applicationContext';
import { checkHasDefaultLogo } from '../../../common/utils/checkHasDefaultLogo';
import { IRatingItem } from '../../../common/types/rating';
import { checkIsNotClickableUrl } from '../../../common/utils/checkIsNotClickableUrl/checkIsNotClickableUrl';
import { CENTURY_DESCR } from '../../constants/century';
import { getShortDescr } from './utils/getShortDescr';

type TRatingItemContainerProps = IRatingItem;

export const RatingItemContainer: React.FC<TRatingItemContainerProps> = ({
  agencyItem,
  expandedItem,
  onExpandedItem,
}) => {
  const { state: openedDescr, toggle: toggleOpenedDescr } = useToggleState(false);

  const device = useDeviceType();

  const { config } = useApplicationContext();

  if (!agencyItem) {
    return null;
  }

  const { agency, agencyAccounts } = agencyItem;

  const medalVisible = config.get<boolean>('info-agency-rating-frontend.medalVisible') || false;

  const medal = findMedal(agency, medalVisible);

  const canExpanded = Boolean(agency.experience || agency.description || agencyAccounts.length !== 0);

  const Item = device === 'phone' ? RatingItemMobile : RatingItem;

  const showsCoverage = (agencyItem.agency.shows / 1000000).toFixed(2);

  const logo = checkHasDefaultLogo(config, agency.userid) ? defaultLogo : agency.urlLogo;

  const agencyLink = checkIsNotClickableUrl(config, agency.userid) ? '#' : agency.url;

  let customAgency = agency.userid === 45262586 ? { ...agency, description: CENTURY_DESCR } : agency;

  customAgency = {
    ...customAgency,
    description: openedDescr ? customAgency.description : getShortDescr(customAgency.description),
  };

  return (
    <Item
      logo={logo}
      link={agencyLink}
      socials={generateDataForLinks(agency)}
      canExpanded={canExpanded}
      currentMedal={medal}
      realAgency={customAgency}
      accounts={agencyAccounts}
      isOpenedDescription={openedDescr}
      toggleDescr={toggleOpenedDescr}
      expandAgency={expandedItem}
      onExpandAgency={onExpandedItem}
      coverage={showsCoverage}
    />
  );
};
